import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2"; // Import SweetAlert2
import { verifyOtp } from "../api";
import Style from "./Style/VerifyOtp.module.css";

const VerifyOtp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { email } = location.state || {}; // Get email from state
  const [otp, setOtp] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    setOtp(e.target.value);
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   try {
  //     // const response = await verifyOtp({ email, otp }); // Verify OTP via API
  //     // const { sellerId } = response.data; // Get sellerId from the API response
  //     // localStorage.setItem("sellerId", sellerId); // ✅ Store in localStorage
  //     const response = await verifyOtp({ email, otp });
  //      console.log("✅ OTP verification response:", response.data);
  //     const sellerId = response.data?.sellerId;
  
  //     if (sellerId) {
  //       localStorage.setItem("sellerId", sellerId.trim()); // ✅ Safe trim
  //       console.log("✅ sellerId saved:", sellerId.trim());
  //     }
  
  //     // Show success alert
  //     Swal.fire({
  //       icon: "success",
  //       title: "Verification Successful",
  //       text: "Your account has been verified. Please log in to continue.",
  //       confirmButtonText: "OK",
  //     }).then(() => {
  //       // Navigate to sign-in page after the alert is closed
  //       navigate("/payment", { state: { sellerId } });
  //     });
  //   } catch (error) {
  //     setErrorMessage(
  //       error.response?.data?.message || "OTP verification failed"
  //     );
  //     setOtp(""); // Reset OTP field after an error
  //   }
  // };


  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const response = await verifyOtp({ email, otp });
      console.log("✅ OTP verification response:", response.data);
      
      const sellerId = response.data?.sellerId;
  
      if (sellerId) {
        localStorage.setItem("sellerId", sellerId.trim());
        console.log("✅ sellerId saved:", sellerId.trim());
  
        // Show success alert
        Swal.fire({
          icon: "success",
          title: "Verification Successful",
          text: "Your account has been verified. Please log in to continue.",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/payment", { state: { sellerId } });
        });
  
      } else {
        console.error("❌ sellerId missing in response");
        setErrorMessage("Verification succeeded, but seller ID is missing.");
      }
  
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "OTP verification failed");
      setOtp(""); // Reset OTP field after an error
    }
  };
  


  return (
    <div className={Style["verify-otp-container"]}>
      <h2>Verify OTP</h2>
      <form onSubmit={handleSubmit}>
        <div className={Style["form-group"]}>
          <label htmlFor="otp">Enter OTP</label>
          <input
            type="text"
            id="otp"
            value={otp}
            onChange={handleChange}
            required
          />
        </div>
        {errorMessage && <p className="error-message">{errorMessage}</p>}
        <button type="submit">Verify OTP</button>
      </form>
    </div>
  );
};

export default VerifyOtp;
